import * as React from 'react';

interface IAnchorProps {
	id: string;
}

export const Anchor: React.FC<IAnchorProps> = (props) => {
	return <span className="anchor" id={props.id} />;
};
